import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { ArrowRowCell, DefaultRowCell, SortedList } from "../../Layout/SortedList";
import ListRow from "./List/ListRow";

export default class GroupedFile extends PureComponent {
  static propTypes = {
    isLoading: PropTypes.bool,
    item: PropTypes.object
  };

  static defaultProps = {
    item: {},
    isLoading: false
  };

  state = {
    isOpen: false
  };

  handleToggleSection = () => this.setState({ isOpen: !this.state.isOpen });

  render() {
    const { display, files = [] } = this.props.item;
    const sorted = files.sort((a, b) => a.fileNameDisplay.localeCompare(b.fileNameDisplay));

    return (
      <Fragment>
        <div role="row" tabIndex="0" className={classNames("sorted-list__row --clickable")} onClick={this.handleToggleSection}>
          <DefaultRowCell className="--x17" value={display} />
          <ArrowRowCell className="--x3" isOpen={this.state.isOpen} />
        </div>

        {this.state.isOpen && <SortedList RowComponent={ListRow} className="sorted-list__documents" data={sorted} isLoading={this.props.isLoading} />}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Document/GroupedFile.js